/** @format */
import { Random } from "@model/utils.js";

let uploads = [];
let accepts = [];
let details = [];
let duplications = [];
let similarities = [];
let content = {};
let keyphrase = [];
let radar = [];

if (window.__ENABLE_MOCK__) {
  const rand = new Random(88675134);

  const pages = [
    {
      url: "https://ja.wikipedia.org/wiki/%E3…",
      title:
        "チンドン屋出典:フリー百科事典『ウィキペディア(Wikipedia)』ナビゲーションに移動検索に移動チンドン…",
      text:
        "チンドン屋成立以後大正期の低迷と戦前・昭和期の繁栄株の暴落、広告取締法の施行などで、大規模な広告楽隊・広告行列は明治40年代に入って低迷し、かわって新聞・雑誌などの広告が盛んとなり、大正期には飛行機を使った宣伝やネオンサインも登場した[52]。この事から、明治末から大正期にかけてを「暗黒期」とする意…",
    },
    {
      url: "https://ja.wikipedia.org/wiki/%E5%BE%92%E7%84%B6%E8%8D%89",
      title: "徒然草 - Wikipedia",
      text:
        "つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ。（Wikipediaより）つれづれなるまゝに、日暮らし、硯にむかひて、心にうつりゆくよしなし事を、そこはかとなく書きつくれば、あやしうこそものぐるほしけれ",
    },
    {
      url: "https://www.aozora.gr.jp/cards/000119/files/624_14544.html",
      title: "中島敦 山月記 - 青空文庫",
      text:
        "残月の光をたよりに林中の草地を通って行った時、果して一匹の猛虎もうこが叢くさむらの中から躍り出た。虎は、あわや袁傪に躍りかかるかと見えたが、忽たちまち身を飜ひるがえして、元の叢に隠れた。叢の中から人間の声で「あぶないところだった」と繰返し呟つぶやくのが聞えた。その声に袁傪は聞き憶おぼえがあった。驚懼きょうくの中にも、彼は咄嗟とっさに思いあたって、叫んだ。「その声は、我が友、李徴子ではないか？」",
    },
    {
      url: "https://www.aozora.gr.jp/cards/000148/files/789_14547.html",
      title: "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
      text:"吾輩わがはいは猫である。名前はまだ無い。どこで生れたかとんと見当けんとうがつかぬ。何でも薄暗いじめじめした所でニャーニャー泣いていた事だけは記憶している。吾輩はここで始めて人間というものを見た。しかもあとで聞くとそれは書生という人間中で一番獰悪どうあくな種族であったそうだ。この書生というのは時々我々を捕つかまえて煮にて食うという話である。しかしその当時は何という考もなかったから別段恐しいとも思わなかった。ただ彼の掌てのひらに載せられてスーと持ち上げられた時何だかフワフワした感じがあったばかりである。"
    }
  ];

  for (let i = 0; i < 64; ++i) {
    const page = pages[rand.next() % 4];
    const status = String((rand.next() % 2) + 1);
    const unread = status == "1" ? "0" : String(rand.next() % 2);
    accepts.push({
      id: 1005875357 + i,
      created: "2020年08月08日 20:21:42",
      modified: "2020年08月10日 08:00:05",
      unread,
      status,
      length:
        String(rand.next() % 1000).substr(0, 1 + (rand.next() % 3)) ??
        rand.next() % 10,
      ticket: String((rand.next() % 10) + 1),
      summary: page.text,
      total: String((rand.next() % 1000000) / 1000000),
      sentences_ratio: String((rand.next() % 1000000) / 1000000),
      similarity_count: String(rand.next() % 30),
      similarity_ratio: String((rand.next() % 1000000) / 1000000),
      feature_ratio: String((rand.next() % 1000000) / 1000000),
      duplication_length: String(rand.next() % 1200),
      duplication_ratio: String((rand.next() % 1000000) / 1000000),
      duplication_count: String(rand.next() % 30),
      type: String((rand.next() % 2) + 1),
    });
  }
  accepts[0].type = "2";
  accepts[0].status = "1";
  accepts[0].total = "0";
  accepts[0].unread = "0";
  accepts[1].type = "2";
  accepts[1].status = "2";
  accepts[1].total = "0";
  accepts[1].unread = "0";
  accepts[2].type = "2";
  accepts[2].status = "2";
  accepts[2].total = "1";
  accepts[2].unread = "1";

  for (let i = 0; i < 10; ++i) {
    const page = pages[rand.next() % 4];
    details.push({
      analytic_id: 1,
      target_id: 1005875358 + i,
      created: "2020年08月08日 23:15:45",
      length:
        String(rand.next() % 1000).substr(0, 1 + (rand.next() % 3)) ??
        rand.next() % 10,
      title: page.title,
      url: page.url,
      total: String((rand.next() % 1000000) / 1000000),
      sentences_ratio: String((rand.next() % 1000000) / 1000000),
      similarity_count: String(rand.next() % 30),
      similarity_ratio: String((rand.next() % 1000000) / 1000000),
      feature_ratio: String((rand.next() % 1000000) / 1000000),
      duplication_length: String(rand.next() % 30),
      duplication_ratio: String((rand.next() % 1000000) / 1000000),
      duplication_count: String(rand.next() % 30),
    });
  }
  details[0].duplication_ratio = "1";
  details[1].duplication_ratio = "0";
  details[0].feature_ratio = "1";
  details[1].feature_ratio = "0";
  details[0].sentences_ratio = "1";
  details[1].sentences_ratio = "0";
  details[0].similarity_ratio = "1";
  details[1].similarity_ratio = "0";

  duplications = [
    {
      length: 4,
      origin_line: 2,
      origin_marker: [
        [
          { line: 2, ch: 0 },
          { line: 2, ch: 5 },
        ],
      ],
      target_line: 0,
      target_marker: [
        [
          { line: 0, ch: 0 },
          { line: 0, ch: 5 },
        ],
      ],
    },
    {
      length: 27,
      origin_line: 2,
      origin_marker: [
        [
          { line: 2, ch: 0 },
          { line: 2, ch: 27 },
        ],
      ],
      target_line: 0,
      target_marker: [
        [
          { line: 0, ch: 0 },
          { line: 0, ch: 27 },
        ],
      ],
    },
    {
      length: 12,
      origin_line: 4,
      origin_marker: [
        [
          { line: 4, ch: 0 },
          { line: 4, ch: 34 },
        ],
      ],
      target_line: 1,
      target_marker: [
        [
          { line: 1, ch: 0 },
          { line: 1, ch: 34 },
        ],
      ],
    },
    {
      length: 38,
      origin_line: 10,
      origin_marker: [
        [
          { line: 10, ch: 0 },
          { line: 10, ch: 6 },
        ],
        [
          { line: 10, ch: 26 },
          { line: 10, ch: 42 },
        ],
      ],
      target_line: 6,
      target_marker: [
        [
          { line: 6, ch: 0 },
          { line: 6, ch: 6 },
        ],
        [
          { line: 6, ch: 26 },
          { line: 6, ch: 42 },
        ],
      ],
    },
    {
      length: 120,
      origin_line: 6,
      origin_marker: [
        [
          { line: 6, ch: 0 },
          { line: 6, ch: 14 },
        ],
      ],
      target_line: 2,
      target_marker: [
        [
          { line: 2, ch: 0 },
          { line: 2, ch: 14 },
        ],
      ],
    },
  ];

  similarities = [
    {
      ratio: 1,
      origin_line: 2,
      origin_marker: [
        [
          { line: 2, ch: 0 },
          { line: 2, ch: 5 },
        ],
      ],
      target_line: 0,
      target_marker: [
        [
          { line: 0, ch: 0 },
          { line: 0, ch: 5 },
        ],
      ],
    },
    {
      ratio: 0.32,
      origin_line: 2,
      origin_marker: [
        [
          { line: 2, ch: 5 },
          { line: 2, ch: 27 },
        ],
      ],
      target_line: 0,
      target_marker: [
        [
          { line: 0, ch: 5 },
          { line: 0, ch: 27 },
        ],
      ],
    },
    {
      ratio: 0.89,
      origin_line: 4,
      origin_marker: [
        [
          { line: 4, ch: 0 },
          { line: 4, ch: 34 },
        ],
      ],
      target_line: 1,
      target_marker: [
        [
          { line: 1, ch: 0 },
          { line: 1, ch: 34 },
        ],
      ],
    },
    {
      ratio: 0.5,
      origin_line: 10,
      origin_marker: [
        [
          { line: 10, ch: 0 },
          { line: 10, ch: 6 },
        ],
        [
          { line: 10, ch: 26 },
          { line: 10, ch: 42 },
        ],
      ],
      target_line: 6,
      target_marker: [
        [
          { line: 6, ch: 0 },
          { line: 6, ch: 6 },
        ],
        [
          { line: 6, ch: 26 },
          { line: 6, ch: 42 },
        ],
      ],
    },
    {
      ratio: 0.49,
      origin_line: 6,
      origin_marker: [
        [
          { line: 6, ch: 0 },
          { line: 6, ch: 14 },
        ],
      ],
      target_line: 2,
      target_marker: [
        [
          { line: 2, ch: 0 },
          { line: 2, ch: 14 },
        ],
      ],
    },
    {
      ratio: 0.9,
      origin_line: 27,
      origin_marker: [
        [
          { line: 27, ch: 0 },
          { line: 27, ch: 15 },
        ],
      ],
      target_line: 19,
      target_marker: [
        [
          { line: 19, ch: 0 },
          { line: 19, ch: 15 },
        ],
      ],
    },
  ];

  content = {
    origin:
      "ふっくら焼ける！\nホットケーキ！？\nふっくら♪厚めの生地でＳＮＳ映えのホットケーキが完成☆30分栄養情報(1枚分)※野菜摂取量はきのこ類・いも類を除くエネルギー294kcalたんぱく質7.7g塩分0.6g野菜摂取量0g材料（3枚分）薄力粉150gベーキングパウダー小さじ2砂糖40g卵1個牛乳130ml「AJINOMOTOサラダ油」少々？\n＊分量は直径１３ｃｍ、３枚分です。\n厚めにふんわりと仕上げたいときは牛乳を１２０ｍｌに調整してください。\nつくり方1ボウルにＡをふるい入れ、泡立て器で混ぜる。\n2別のボウルに卵を割りほぐし、牛乳を加えて混ぜる。\n3（１）のボウルに（２）を加え、泡立て器で粉っぽさがなくなるまで混ぜ、生地を作る。\n4フライパンに油をしみ込ませたキッチンペーパーで油を薄く塗り、フライパンを熱する。\n5ぬれたふきんの上にフライパンを置いて熱を取り、再び弱火にかけ、（３）の生地をおたま１杯、上から中心に落とす（こうすると丸い形になる）。\n6約３分焼き、表面にプツプツと穴がでてきたら裏返し、約２分弱火のまま焼き、取り出す。\n7２枚目からは油をひかずにフライパンをぬれふきんの上に置いて熱を取り、弱火にかけて同様に焼く。\n8器に盛り、お好みでバター、メープルシロップをかける。\n＊ベーキングパウダー入りの生地はすぐに焼かないとふくらみが悪くなるので、　混ぜたらすぐに焼きましょう。\n味の素株式会社©\nふっくら焼ける！\nホットケーキ！？\nふっくら♪厚めの生地でＳＮＳ映えのホットケーキが完成☆30分栄養情報(1枚分)※野菜摂取量はきのこ類・いも類を除くエネルギー294kcalたんぱく質7.7g塩分0.6g野菜摂取量0g材料（3枚分）薄力粉150gベーキングパウダー小さじ2砂糖40g卵1個牛乳130ml「AJINOMOTOサラダ油」少々？\n＊分量は直径１３ｃｍ、３枚分です。\n厚めにふんわりと仕上げたいときは牛乳を１２０ｍｌに調整してください。\nつくり方1ボウルにＡをふるい入れ、泡立て器で混ぜる。\n2別のボウルに卵を割りほぐし、牛乳を加えて混ぜる。\n3（１）のボウルに（２）を加え、泡立て器で粉っぽさがなくなるまで混ぜ、生地を作る。\n4フライパンに油をしみ込ませたキッチンペーパーで油を薄く塗り、フライパンを熱する。\n5ぬれたふきんの上にフライパンを置いて熱を取り、再び弱火にかけ、（３）の生地をおたま１杯、上から中心に落とす（こうすると丸い形になる）。\n6約３分焼き、表面にプツプツと穴がでてきたら裏返し、約２分弱火のまま焼き、取り出す。\n7２枚目からは油をひかずにフライパンをぬれふきんの上に置いて熱を取り、弱火にかけて同様に焼く。\n8器に盛り、お好みでバター、メープルシロップをかける。\n＊ベーキングパウダー入りの生地はすぐに焼かないとふくらみが悪くなるので、　混ぜたらすぐに焼きましょう。\n味の素株式会社©",
    target:
      "ふっくら♪厚めの生地でＳＮＳ映えのホットケーキが完成☆薄力粉150gベーキングパウダー小さじ2砂糖40g卵1個牛乳130ml「AJINOMOTOサラダ油」少々＊分量は直径１３ｃｍ、３枚分です。\n厚めにふんわりと仕上げたいときは牛乳を１２０ｍｌに調整してください。\n2別のボウルに卵を割りほぐし、牛乳を加えて混ぜる。\n3（１）のボウルに（２）を加え、泡立て器で粉っぽさがなくなるまで混ぜ、生地を作る。\n4フライパンに油をしみ込ませたキッチンペーパーで油を薄く塗り、フライパンを熱する。\n5ぬれたふきんの上にフライパンを置いて熱を取り、再び弱火にかけ、（３）の生地をおたま１杯、上から中心に落とす（こうすると丸い形になる）。\n6約３分焼き、表面にプツプツと穴がでてきたら裏返し、約２分弱火のまま焼き、取り出す。\n7２枚目からは油をひかずにフライパンをぬれふきんの上に置いて熱を取り、弱火にかけて同様に焼く。\n8器に盛り、好みでバター、メープルシロップをかける。\n＊ベーキングパウダー入りの生地はすぐに焼かないとふくらみが悪くなるので、　混ぜたらすぐに焼きましょう。\nおすすめコンテンツ味の素KKがおすすめするコンテンツをご紹介注目のレシピ特集閲覧履歴\nふっくら♪厚めの生地でＳＮＳ映えのホットケーキが完成☆薄力粉150gベーキングパウダー小さじ2砂糖40g卵1個牛乳130ml「AJINOMOTOサラダ油」少々＊分量は直径１３ｃｍ、３枚分です。\n厚めにふんわりと仕上げたいときは牛乳を１２０ｍｌに調整してください。\n2別のボウルに卵を割りほぐし、牛乳を加えて混ぜる。\n3（１）のボウルに（２）を加え、泡立て器で粉っぽさがなくなるまで混ぜ、生地を作る。\n4フライパンに油をしみ込ませたキッチンペーパーで油を薄く塗り、フライパンを熱する。\n5ぬれたふきんの上にフライパンを置いて熱を取り、再び弱火にかけ、（３）の生地をおたま１杯、上から中心に落とす（こうすると丸い形になる）。\n6約３分焼き、表面にプツプツと穴がでてきたら裏返し、約２分弱火のまま焼き、取り出す。\n7２枚目からは油をひかずにフライパンをぬれふきんの上に置いて熱を取り、弱火にかけて同様に焼く。\n8器に盛り、好みでバター、メープルシロップをかける。\n＊ベーキングパウダー入りの生地はすぐに焼かないとふくらみが悪くなるので、　混ぜたらすぐに焼きましょう。\nおすすめコンテンツ味の素KKがおすすめするコンテンツをご紹介注目のレシピ特集閲覧履歴",
  };

  uploads = [
    {
      id: 228,
      title:
        "https://ja.wikipedia.org/wiki/%E3%83%81%E3%83%B3%E3%83%89%E3%83%B3%E5%B1%8B",
      count: 2,
      length: 1000,
      text:
        "チンドン屋出典:フリー百科事典『ウィキペディア(Wikipedia)』ナビゲーションに移…",
    },
    {
      id: 229,
      title:
        "https://ja.wikipedia.org/wiki/%E3%82%A4%E3%82%AE%E3%83%AA%E3%82%B9%E3%83%BB%E3%83%AB%E3%83%8D%E3%82%B5%E3%83%B3%E3%82%B9%E6%BC%94%E5%8A%87",
      count: 1,
      length: 500,
      text:
        "イギリス・ルネサンス演劇:フリー百科事典『ウィキペディア(Wikipedia)』ナビゲーションに移…",
    },
    {
      id: null,
      title: "31.txt",
      count: null,
      length: 9999,
      text: "コンテンツの文字数上限（20000文字）を超えています。",
    },
  ];

  keyphrase = {
    origin: [
      {
        text: "ホットケーキ",
        size: 152,
      },
      {
        text: "コメント",
        size: 55,
      },
      {
        text: "みんな",
        size: 52,
      },
      {
        text: "おやつ",
        size: 52,
      },
      {
        text: "できあがり",
        size: 42,
      },
      {
        text: "チョコ クリーム",
        size: 42,
      },
      {
        text: "すごく",
        size: 39,
      },
      {
        text: "レシピ",
        size: 38,
      },
      {
        text: "17 今川 焼き みたい",
        size: 35,
      },
      {
        text: "ポイント",
        size: 34,
      },
      {
        text: "バナナ",
        size: 34,
      },
      {
        text: "こんな",
        size: 34,
      },
      {
        text: "ホント",
        size: 32,
      },
      {
        text: "作り方",
        size: 29,
      },
      {
        text: "大好き",
        size: 26,
      },
      {
        text: "21 ほんと",
        size: 26,
      },
      {
        text: "チーズ",
        size: 22,
      },
      {
        text: "膨らみ",
        size: 22,
      },
      {
        text: "楽しく",
        size: 20,
      },
      {
        text: "ホットケーキ ミックス",
        size: 20,
      },
      {
        text: "ホットプレート",
        size: 18,
      },
      {
        text: "美味しさ",
        size: 18,
      },
      {
        text: "火加減",
        size: 18,
      },
      {
        text: "うまく",
        size: 17,
      },
      {
        text: "ミックス",
        size: 17,
      },
      {
        text: "欲しい",
        size: 15,
      },
      {
        text: "大きく",
        size: 15,
      },
      {
        text: "プレーン",
        size: 15,
      },
      {
        text: "ボール",
        size: 13,
      },
      {
        text: "52 コメント",
        size: 13,
      },
      {
        text: "ぶきん",
        size: 12,
      },
      {
        text: "森永 ホットケーキ ミックス",
        size: 8,
      },
    ],
    target: [
      {
        text: "ホットケーキ",
        size: 152,
      },
      {
        text: "コメント",
        size: 55,
      },
      {
        text: "みんな",
        size: 52,
      },
      {
        text: "おやつ",
        size: 52,
      },
      {
        text: "できあがり",
        size: 42,
      },
      {
        text: "チョコ クリーム",
        size: 42,
      },
      {
        text: "すごく",
        size: 39,
      },
      {
        text: "レシピ",
        size: 38,
      },
      {
        text: "17 今川 焼き みたい",
        size: 35,
      },
      {
        text: "ポイント",
        size: 34,
      },
      {
        text: "バナナ",
        size: 34,
      },
      {
        text: "こんな",
        size: 34,
      },
      {
        text: "ホント",
        size: 32,
      },
      {
        text: "作り方",
        size: 29,
      },
      {
        text: "大好き",
        size: 26,
      },
      {
        text: "21 ほんと",
        size: 26,
      },
      {
        text: "チーズ",
        size: 22,
      },
      {
        text: "膨らみ",
        size: 22,
      },
      {
        text: "楽しく",
        size: 20,
      },
      {
        text: "ホットケーキ ミックス",
        size: 20,
      },
      {
        text: "ホットプレート",
        size: 18,
      },
      {
        text: "美味しさ",
        size: 18,
      },
      {
        text: "火加減",
        size: 18,
      },
      {
        text: "うまく",
        size: 17,
      },
      {
        text: "ミックス",
        size: 17,
      },
      {
        text: "欲しい",
        size: 15,
      },
      {
        text: "大きく",
        size: 15,
      },
      {
        text: "プレーン",
        size: 15,
      },
      {
        text: "ボール",
        size: 13,
      },
      {
        text: "52 コメント",
        size: 13,
      },
      {
        text: "ぶきん",
        size: 12,
      },
      {
        text: "森永 ホットケーキ ミックス",
        size: 8,
      },
    ],
  };

  radar = [
    [
      {
        axis: "ホットケーキ",
        value: 15.247495125620155,
      },
      {
        axis: "コメント",
        value: 5.590380409540645,
      },
      {
        axis: "みんな",
        value: 5.283524212513227,
      },
      {
        axis: "おやつ",
        value: 5.2373174578225825,
      },
      {
        axis: "できあがり",
        value: 4.248889069849332,
      },
      {
        axis: "チョコクリーム",
        value: 4.226529447776553,
      },
      {
        axis: "すごく",
        value: 3.916283451735551,
      },
      {
        axis: "レシピ",
        value: 3.8100208769820343,
      },
      {
        axis: "17今川焼きみたい",
        value: 3.512646859399937,
      },
      {
        axis: "ポイント",
        value: 3.4747249989734232,
      },
      {
        axis: "バナナ",
        value: 3.47071573131833,
      },
      {
        axis: "こんな",
        value: 3.414641844638254,
      },
    ],
  ];

  radar.push(
    radar[0].reduce((acc, cur) => {
      acc.push({
        axis: cur.axis,
        value: (cur.value * (rand.next() % 1500)) / 1000,
      });
      return acc;
    }, [])
  );
}

export {
  uploads,
  accepts,
  details,
  duplications,
  similarities,
  content,
  keyphrase,
  radar,
};
